module.exports = __webpack_public_path__ + "static/media/bg-pentagon.aced7052.svg";